import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { HelpDeskContentType } from './types/help-desk-content-type';
import { HelpDeskService } from './services/help-desk.service';
import { take } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'tc-help-desk',
    imports: [
        CommonModule
    ],
    templateUrl: './help-desk.component.html',
    styleUrls: ['./help-desk.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HelpDeskComponent implements OnInit {
  @Input() helpDeskContentType: HelpDeskContentType;
  content: string;
  constructor(
    private helpDeskService: HelpDeskService
  ) { }

  ngOnInit() {
    this.getContent();
  }

  private getContent(): void {
    if (!this.helpDeskContentType) {
      return;
    }
    this.helpDeskService.getHelpContent(this.helpDeskContentType)
      .pipe(take(1))
      .subscribe(
        res => {
          this.content = res['data']['content'];
        }
      );
  }

}
